import { render, staticRenderFns } from "./UpdateProfile.vue?vue&type=template&id=2c118684&scoped=true&"
import script from "./UpdateProfile.vue?vue&type=script&lang=ts&"
export * from "./UpdateProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c118684",
  null
  
)

export default component.exports